// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__QejQ5","formControl":"addForm_formControl__0fSbm","list":"addForm_list__kzj2f","btnWrpper":"addForm_btnWrpper__P7ue9"};